//#region src/assets/vana-logo.svg
var vana_logo_default = "" + new URL("vana-logo-B0pj6CgB.svg", import.meta.url).href;
//#endregion
export { vana_logo_default as default };

//# sourceMappingURL=vana-logo.js.map